import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-exchange-policy',
    templateUrl: './exchange-policy.component.html'
})
export class ExchangePolicyComponent implements OnInit {
    constructor() { }

    ngOnInit() {
    	window.scrollTo(0,0);
    }
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/additional-pages/exchange-policy/exchange-policy.component.ts